import React from 'react';

import {
  AbsIcon,
  AirbagIcon,
  CarDoorIcon,
  CarSeatIcon,
  CreditCartIcon,
  DateIcon,
  DrivingLicenseIcon,
  GasStationIcon,
  ManualTransmissionIcon,
  RoadIcon,
  SuitcaseIcon,
} from '@assets/icons';

import { VehicleSpecificationsWrapper } from '../CarRentalCard.styled';
import VehicleSpecificationIcon from './VehicleSpecificationIcon';
import {
  CarRentalCarConditionProps,
  CarRentalCarFeatureProps,
  CarRentalCarReservationProps,
} from '../CarRentalCardProps';

interface IVehicleSpecifications {
  features: CarRentalCarFeatureProps;
  conditions: CarRentalCarConditionProps;
  reservation: CarRentalCarReservationProps;
}

const VehicleSpecifications = ({
  features,
  conditions,
  reservation,
}: IVehicleSpecifications) => {
  return (
    <>
      <VehicleSpecificationsWrapper>
        <h6>Araç Özellikleri</h6>
        <ul>
          {features?.seatsCount ? (
            <li>
              <VehicleSpecificationIcon icon={CarSeatIcon} />
              {features?.seatsCount} Koltuk
            </li>
          ) : null}

          {features?.doorCount ? (
            <li>
              <VehicleSpecificationIcon icon={CarDoorIcon} />
              {features?.doorCount} Kapı
            </li>
          ) : null}

          {features?.luggageCount ? (
            <li>
              <VehicleSpecificationIcon icon={SuitcaseIcon} />
              {features?.luggageCount} Bagaj
            </li>
          ) : null}

          {features?.hasPessengerAirbag ? (
            <li>
              <VehicleSpecificationIcon icon={AirbagIcon} />
              Yolcu Airbag
            </li>
          ) : null}

          {features?.hasAirLockBrakingSystem ? (
            <li>
              <VehicleSpecificationIcon icon={AbsIcon} />
              ABS
            </li>
          ) : null}

          {features?.fuelType ? (
            <li>
              <VehicleSpecificationIcon icon={GasStationIcon} />
              {features?.fuelType}
            </li>
          ) : null}

          {features?.transmissionType ? (
            <li>
              <VehicleSpecificationIcon icon={ManualTransmissionIcon} />
              {features?.transmissionType}
            </li>
          ) : null}
        </ul>
      </VehicleSpecificationsWrapper>
      <VehicleSpecificationsWrapper>
        <h6>Kiralama Koşulları</h6>
        <ul>
          {reservation?.maxKilometer ? (
            <li>
              <VehicleSpecificationIcon icon={RoadIcon} />
              {reservation?.maxKilometer} Km
            </li>
          ) : null}
          {conditions?.minAge ? (
            <li>
              <VehicleSpecificationIcon icon={DateIcon} />
              {conditions?.minAge} Yaş Ve Üstü
            </li>
          ) : null}
          {conditions?.minDriverLicence ? (
            <li>
              <VehicleSpecificationIcon icon={DrivingLicenseIcon} />
              Ehliyet Yaşı {conditions?.minDriverLicence} ve Üzeri
            </li>
          ) : null}
          {conditions?.minCreditCard ? (
            <li>
              <VehicleSpecificationIcon icon={CreditCartIcon} />
              {conditions?.minCreditCard} Kredi Kartı
            </li>
          ) : null}
        </ul>
      </VehicleSpecificationsWrapper>
    </>
  );
};

export default VehicleSpecifications;
